import { Stack, StackProps } from '@mui/material';
import { toSxArray } from 'src/utils/sx';

/**
 * The vertical rhythm every side-panel property row shares. A row keeps its pitch
 * whatever its value renders — plain text, a select trigger, a wrapping pill list —
 * because the height comes from the row, not from the control inside it.
 *
 * A row with a taller or custom control sets only `minHeight` and `paddingY` from
 * here; a label always reserves `SIDE_PANEL_ROW_CONTENT_HEIGHT` so its first line
 * sits at the same offset in a single-line and a wrapping row alike.
 */
export const SIDE_PANEL_ROW_CONTENT_HEIGHT = '1.8125rem';

export const SIDE_PANEL_ROW_PADDING_Y = '0.125rem';

export const SIDE_PANEL_ROW_MIN_HEIGHT = '2.0625rem';

/**
 * One side-panel property row. Every prop is a default, so a row with a wrapping
 * value or its own direction overrides just that one and keeps the shared pitch.
 */
export const SidePanelRow = ({ sx, ...props }: StackProps) => (
  <Stack
    direction="row"
    alignItems="center"
    minHeight={SIDE_PANEL_ROW_MIN_HEIGHT}
    paddingBlock={SIDE_PANEL_ROW_PADDING_Y}
    {...props}
    sx={[
      // Flex children default to `min-width: auto`, which is their content's
      // width — a long value would then push past the panel instead of
      // truncating inside it.
      { '& > *': { minWidth: 0 } },
      ...toSxArray(sx),
    ]}
  />
);
